import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { formatNumber } from '@/modules/expense-reports/lib/strings';
import type { RowType } from '@/modules/expense-reports/types';
interface NumberCellProps {
  value: number;
  className?: string;
  isIncome?: boolean;
  rowType?: RowType;
}
function NumberCell(t0) {
  const $ = _c(8);
  const {
    value,
    className,
    isIncome: t1,
    rowType: t2
  } = t0;
  const isIncome = t1 === undefined ? false : t1;
  const rowType = t2 === undefined ? "normal" : t2;
  const negative = value < 0;
  const isTotal = rowType === "total";
  const color = negative ? isIncome ? "text-status-success" : isTotal ? "text-destructive" : "text-destructive/50" : isTotal ? "text-foreground" : "text-foreground/70";
  let t3;
  if ($[0] !== className || $[1] !== color) {
    t3 = cn("text-base/6 font-semibold md:px-2 md:py-2 md:text-sm/4.5 lg:px-4 lg:text-base/6", color, className);
    $[0] = className;
    $[1] = color;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== value) {
    t4 = formatNumber(value);
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div data-type="number-cell" className={t3}>{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
export { NumberCell };